<template>
  <div class="container">
    <div class="footerbox">
      <div class="vleft">
        <div class="snavBar">
          <img src="../assets/img/logo2x.png" alt />
          <router-link to="/">回到首页</router-link>
          <router-link to="/cases">查看案例</router-link>
        </div>
        <div class="callwe">
          <div>
            <img src="../assets/img/eml.png" alt />
            <span>sealyyg@163.com</span>
          </div>
          <div>
            <img src="../assets/img/phone.png" alt />
            <span>010-85753879</span>
          </div>
          <div>
            <img src="../assets/img/dw.png" alt />
            <span>北京市朝阳区八里庄西里61号远洋商务大厦509室</span>
          </div>
        </div>
      </div>
      <div class="vrights" style="width:400 !importang;">
        <p>Copyright © 2015 sealyyg.com All Rights Reserved</p>
        <p>
          <a href="http://www.sealyyg.com/wh.jpg" target="_blank"
            >网络文化经营许可证京网文[2021]0475-125号</a
          >
        </p>
        <p>版权所有·北京思励格信息技术有限公司</p>
        <a href="https://beian.miit.gov.cn">京ICP备11007746号-1</a>
        <div>
          <img src="../assets/img/weixin.png" alt="" />
          <img src="../assets/img/weibo.png" alt="" />
          <img src="../assets/img/qq.png" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  methods: {}
};
</script>

<style lang="less" scoped>
.container {
  width: 100%;
  height: 314px;
  box-sizing: border-box;
  background: #1e388c;
  box-sizing: border-box;
  padding: 70px 0;
  .footerbox {
    width: 1200px;
    margin: auto;
    display: flex;
    box-sizing: border-box;
    .vleft {
      width: 800px;
    }
    .vrights {
      width: 400px !important;
      p {
        font-size: 12px;
        color: #afc2ff;
        font-family: SourceHanSansCN-Regular;
        text-align: right;
      }
      a {
        display: block;
        font-size: 12px;
        color: #afc2ff;
        font-family: SourceHanSansCN-Regular;
        text-align: right;
      }
      div {
        margin-top: 40px;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        img {
          width: 60px;
          height: 60px;
          margin-left: 30px;
        }
      }
    }
  }
  .snavBar {
    width: 800px;
    display: flex;
    align-items: center;
    img {
      width: 180px;
      height: 35px;
      margin-right: 50px;
    }
    span {
      margin-left: auto;
      color: #fefefe;
    }
    a {
      height: 34px;
      width: 80px;
      text-align: center;
      line-height: 34px;
      text-decoration: none;
      margin-right: 20px;
      color: #fefefe;
      font-size: 15px;
      font-family: SourceHanSansCN-Medium;
      box-sizing: border-box !important;
      font-weight: bold;
    }
    a:hover {
      box-sizing: border-box;
      color: white;
    }
  }
  .callwe {
    width: 800px;
    margin-top: 40px;
    div {
      display: flex;
      align-items: center;
      width: 500px;
      margin-left: 190px;
      margin-top: 15px;
      span {
        width: 500px;
        color: #fefefe !important;
        font-size: 15px;
        font-weight: bold;
        line-height: 27px;
      }
      img {
        margin-right: 28px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/vfooter.vue